import React, { useCallback } from 'react';

import { Upgrade } from '@/components/AccountPanel/components/Upgrade';
import { PANEL_TRANSITION_TIMEOUT } from '@/config/constants';
import { useAuth } from '@/providers/AuthProvider';
import { Profile } from 'interfaces';

import { SupportUs } from '../AccountPanel/components/SupportUs';
import { Scrollbar } from '../Scrollbar';
import { AsaphDialogHeader, AsaphDialogHeaderButton } from '../shared/Dialog';
import AsaphDialog from '../shared/Dialog/AsaphDialog';
import styles from './SupportUsModal.module.scss';

export interface IPropsSupportUsModal {
	setOpen: (open: boolean) => void;
}

export const SupportUsModal: React.FC<IPropsSupportUsModal> = ({ setOpen }) => {
	const handleClose = useCallback(() => {
		setOpen(false);
	}, [setOpen]);

	return (
		<AsaphDialog open={true} onClose={handleClose}>
			<div className={styles['paid-modal__toolbar']}>
				<AsaphDialogHeader
					leadingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: (
							<AsaphDialogHeaderButton
								type="text"
								label="Cancel"
								handlePress={handleClose}
							/>
						),
					}}
					title={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						label: '',
					}}
					trailingButton={{
						needsFadeIn: true,
						fadeTimeout: PANEL_TRANSITION_TIMEOUT,
						component: null,
					}}
				/>
			</div>
			<div className={styles['paid-modal__content']}>
				<SupportUs
					onClose={() => setOpen(false)}
					popDisplayState={() => {}}
				/>
			</div>
		</AsaphDialog>
	);
};
